module.exports = __webpack_public_path__ + "media/images/views/lp/recruiter/earn/recruiter-phone-c10c44f869986e19c04b799b8597b2f0.png";